import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import ExampleComponent from '../ExampleComponent'
import { GlobalVariables } from 'Globals/GlobalVariables'

const MainComponent = (props: MicroFrontendProps) => {
   console.log('Props from DISCO: ', props)
  return (
    <AppContainer colorMode={props.colorMode}>
        <TextWidth>
          <ExampleComponent />
          <button onClick={() => props?.trackEvent("testEventHybridApp", {"pressed a button": true})} >
            Track Event
          </button>
        </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
